export default __webpack_public_path__ + "static/media/selfie boothlabel.a081685c.png";